import React, { useEffect } from 'react';
import type { SingleCommonType } from '../../types';
import { commonBackInfo } from '../../utils';
import { engagementsPlaceholder } from '../../constants/placeholder';
import CustomFollowerRange from '../../components/CustomFollowerRange';
import { useSetRangeDefaultValue, dealwithRangeDataWithNewFormat } from '../../hooks/init';
import { useIntl } from 'umi';
import './index.scss';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

export default function EngagementRange({
  onChange,
  defaultValue,
  filterValue,
  defaultKey,
  lang,
  oriDefaultFilter,
  backOriDefaultValue,
}: SingleCommonType) {
  const { formatMessage } = useIntl();

  const { rangeValue, setRangeValue, followerRef, options, diffClassName } =
    useSetRangeDefaultValue({
      defaultValue,
      filterValue,
      defaultKey: 'engagements',
      oriDefaultFilter,
      backOriDefaultValue,
      options: [
        { text: 'All', value: '-' },
        { text: '0 ~ 1000', value: '0-1' },
        { text: '1000 ~ 5000', value: '1-5' },
        { text: '5000 ~ 10000', value: '5-10' },
        { text: '> 10000', value: '10-' },
      ],
      dealwithDateFunc: dealwithRangeDataWithNewFormat,
    });
  useEffect(() => {
    const showHeader = followerRef.current?.buttonElement?.(rangeValue);
    const data = [];
    if (rangeValue !== '-') {
      const [start, end] = rangeValue.split('-');
      // 新格式: 使用 start/end
      type DataItem = { start: number; end?: number };
      const dataItem: DataItem = {
        start: Number(start) * 1000,
      };
      if (end !== '') {
        dataItem.end = Number(end) * 1000;
      }
      data.push(dataItem);
    }

    onChange?.(
      'engagementsRange',
      commonBackInfo({ engagements: data }, { engagementsRange: showHeader }),
    );
  }, [rangeValue, formatMessage]);

  return (
    <div className={`dbo-engagement-range-wrapper ${diffClassName}`}>
      <CustomFollowerRange
        lang={lang}
        ref={followerRef}
        options={options}
        setRangeValue={setRangeValue}
        rangeValue={rangeValue}
        pointKey={FilterButtonPoint.engagementsRange}
        placeholder={engagementsPlaceholder}
      ></CustomFollowerRange>
    </div>
  );
}
